

import { SvgIcon, SvgIconProps } from "@mui/material";

export const AddScheduleIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
        d="M10 15H7a4 4 0 0 0-4 4v1"
      />
      <circle
        cx="11"
        cy="7"
        r="4"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
        d="M18.3 18h-1.8M16.5 18v-1.8"
      />
      <circle
        cx="16.75"
        cy="17.75"
        r="4.25"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
      />
    </svg>
  </SvgIcon>
);
